






















import { Component, Vue } from "nuxt-property-decorator";
import headHelper from "~/helper/head";

@Component<AuditWebsitesPage>({
  nuxtI18n: {
    paths: {
      en: "/services/audit-websites",
      pl: "/uslugi/audyt-stron-internetowych"
    }
  },
  head() {
    return headHelper(null, {
      title: this.$tc("pages.audit-websites.meta.title")
    });
  }
})
export default class AuditWebsitesPage extends Vue {
  auditWebsites!: any;
}
